import { cx } from "@jugl-web/utils";
import { FC } from "react";
import defaultLogoSrc from "./assets/default-logo.svg?url";

type LiveChatUILogoSize = "sm" | "md";

export interface LiveChatUILogoProps {
  src: string;
  size: LiveChatUILogoSize;
  /** Avatar-only mode if title is not provided */
  title?: string;
  className?: string;
}

const classesBySize: Record<LiveChatUILogoSize, string> = {
  sm: "h-5 w-5",
  md: "h-6 w-6",
};

export const LiveChatUILogo: FC<LiveChatUILogoProps> = ({
  src,
  size,
  title,
  className,
}) => {
  return (
    <div className={cx("flex items-center gap-3", className)}>
      <img
        src={src || defaultLogoSrc}
        alt={title}
        className={cx(
          "shrink-0 rounded-full object-cover",
          classesBySize[size]
        )}
      />
      {title && (
        <span className="text-dark font-secondary truncate text-base font-medium">
          {title}
        </span>
      )}
    </div>
  );
};
